<template>
  <div class="user-list">
    <div class="tflex"><span>课程列表</span><el-link type="primary" @click="getList">刷新</el-link></div>
    <div class="top">
      <div class="left">
        <div style="width: 100px; text-align: center">
          <i class="el-icon-user-solid"></i>
        </div>
        <div>
          <p>{{ username }}</p>
          <p>账号：{{ uuid }}</p>
        </div>
      </div>
      <div class="right">
        <div>
          <p>累计播放次数</p>
          <h3>{{ pageData.games }}</h3>
        </div>
        <div>
          <p>累计播放场数</p>
          <h3>{{ pageData.games1 }}</h3>
        </div>
        <div>
          <p>累计观看人数</p>
          <h3>{{ pageData.count_people }}</h3>
        </div>
        <div>
          <p>累计观看时长</p>
          <h3>{{ pageData.count_time }}</h3>
        </div>
      </div>
    </div>
    <div class="search-bar">
      <el-input v-model="searchParam.keyword_search" placeholder="课程名称" clearable @clear="getList"></el-input>
      <el-select v-model="searchParam.cate_uuid" placeholder="直播类型" clearable @clear="getList">
        <el-option v-for="item in typeList" :label="item.title" :value="item.uuid"></el-option>
      </el-select>
      <el-select v-model="searchParam.play_status" placeholder="直播状态" clearable @clear="getList">
        <el-option label="直播中" value="2"></el-option>
        <el-option label="未开始" value="1"></el-option>
        <el-option label="已结束" value="3"></el-option>
      </el-select>
      <el-date-picker
        v-model="dates"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="changTimes"
      >
      </el-date-picker>
      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button type="primary" @click="resetSearch">重置</el-button>
    </div>

    <div class="table">
      <p>今日待上课：{{ pageData.today_live_count }}次</p>
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column label="编号" fixed="left" width="120px" type="index"> </el-table-column>
        <el-table-column prop="title" label="直播名称" width="120px"> </el-table-column>

        <el-table-column prop="teacher_name" label="教师名称" width="120px"> </el-table-column>
        <el-table-column prop="cate" label="课程类型" width="160">
          <template slot-scope="scope">
            {{
              scope.row.cate
                .map((item) => {
                  return item.title;
                })
                .join("、")
            }}
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开播时间"> </el-table-column>
        <el-table-column prop="end_time" label="结束时间"> </el-table-column>
        <el-table-column prop="play_status" label="直播状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.play_status == 2">直播中</el-tag>
            <el-tag v-if="scope.row.play_status == 1">未开始</el-tag>
            <el-tag v-if="scope.row.play_status == 3">已结束</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button v-if="scope.row.play_status == 1" class="mid-blue" @click="startLive(scope.row)"
              >开始直播</el-button
            >

            <el-button v-if="scope.row.play_status == 2" class="mid-blue" @click="inToRoom(scope.row)"
              >房间监控</el-button
            >

            <el-button class="mid-red" @click="showData(scope.row)">数据</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { LiveCourse, deleteLive, setTopLive, LiveStatus, getLiveType, startLive } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
import Utils from "@/jslibs/utils";

export default {
  mixins: [mixin],
  data() {
    return {
      username: Utils.getCookie("X-Access-Name"),
      uuid: Utils.getCookie("X-Access-Account"),
      pageData: {},
      dates: [],
      loading: false,
      teacherList: [],
      searchParam: {},
      typeList: [],
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getType();
  },
  methods: {
    resetSearch() {
      this.searchParam = {};
      this.dates = [];
      this.getList();
    },
    changTimes(val) {
      this.searchParam.start_time = val ? val[0] : "";
      this.searchParam.end_time = val ? val[1] : "";
      if (!val) {
        this.getList();
      }
    },
    getType() {
      getLiveType().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    showData(row) {
      console.log(row);
      this.$router.push({
        path: "/live-data",
        query: { ...row, uuid: row.info_uuid },
      });
    },
    inToRoom(row) {
      this.$router.push({
        path: "/watch-live",
        query: { ...row, isLiver: true },
      });
    },
    async startIn(row) {
      const res = await startLive(row.uuid, { type: "start" });
      if (res) {
        this.$router.push({
          path: "/watch-live",
          query: { ...row, isLiver: true, ...res },
        });
      } else {
        this.$message.info(res.msg);
      }
    },
    startLive(row) {
      this.$confirm("点击开始直播后，用户可进入直播间，观看直播", "是否确定开始直播", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.startIn(row);
        })
        .catch(() => {});
    },

    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await LiveCourse(param);
      this.loading = false;
      if (res) {
        this.pageData = res;
      }
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.tflex {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}
.search-bar {
  border: 1px solid #eee;
  padding: 10px;
}
.table {
  border: 1px solid #eee;
  padding: 10px;
  margin-top: 10px;
}
.top {
  display: flex;
  border: 1px solid #eee;
  padding: 30px 10px;
  font-size: 16px;
  margin-bottom: 20px;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
  }
  .right {
    display: flex;
    text-align: center;
    div {
      padding: 0 20px;
      border-right: 1px solid #bbb;
      &:last-child {
        border: none;
      }
      p {
        color: #999;
      }
      h3 {
        font-size: 32px;
      }
    }
  }
}
</style>
